import { render, staticRenderFns } from "./PatLegalesPage.vue?vue&type=template&id=bc6aac0a"
import script from "./PatLegalesPage.vue?vue&type=script&lang=js"
export * from "./PatLegalesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports